import { render } from "./ResourcePreloaderPropsCmp.vue?vue&type=template&id=30330285"
import script from "./ResourcePreloaderPropsCmp.vue?vue&type=script&lang=js"
export * from "./ResourcePreloaderPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__